import { useState } from "react"

import { createFileRoute, Link, redirect } from "@tanstack/react-router"

import { ForgotPasswordForm } from "@/components/account/ForgotPasswordForm"

export const Route = createFileRoute("/(public)/_account/forgot-password")({
  beforeLoad: ({ context: { store } }) => {
    if (store.getState().isAuthenticated) {
      throw redirect({ to: "/" })
    }
  },
  component: RouteComponent,
  wrapInSuspense: false,
})

function RouteComponent() {
  const [emailSent, setEmailSent] = useState(false)

  if (emailSent) {
    return (
      <>
        <div className="mb-4">
          <h2 className="text-2xl font-bold text-neutral-800">
            Check your email
          </h2>
          <p className="mb-4 text-lg text-neutral-500">
            {"We've sent a password reset link to your email address." +
              " Please check your inbox and follow the instructions" +
              " to reset your password."}
          </p>
        </div>
        <Link
          className="mt-4 block text-center text-neutral-600 underline"
          to="/login"
        >
          Back
        </Link>
      </>
    )
  }

  return (
    <>
      <div className="mb-4">
        <h2 className="text-2xl font-bold text-neutral-800">
          Forgotten your password?
        </h2>
        <p className="text-lg text-neutral-500">
          {
            "Enter your email address below, and we'll send you instructions for setting a new one."
          }
        </p>
      </div>

      <ForgotPasswordForm onSuccess={() => setEmailSent(true)} />

      <Link
        className="mt-4 block text-center text-neutral-600 underline"
        to="/login"
      >
        Back
      </Link>
    </>
  )
}
